module.exports = __webpack_public_path__ + "static/type-brigade-50-paul-commercial-classics-3-b4d5352079c15ce2821333bc2a5f0861.png";